import React from 'react';
import { walkClaimText } from '../../../../lib/walkClaimText';
import type { SiteRagReport } from '../../../../types/siteRag';
import { SectionShell } from '../SectionShell';
import { PowerIntentIntroStrip } from './PowerIntentIntroStrip';
import { useEffectiveReportTheme } from '../../../../lib/useEffectiveReportTheme';
import { EditorialSubsection, EditorialDatumStrip, EditorialCallout } from '../../report/editorial';
import { resolveSectionCallout } from '../../../../lib/reportRendering/reportSectionCallouts';

export const GridCapacitySection: React.FC<{ report: SiteRagReport; label: string }> = ({ report, label }) => {
  const theme = useEffectiveReportTheme();
  const pa = report.powerAnalysis;
  const substation = pa?.substationAssessment;
  const capacity = pa?.capacityAnalysis;
  const hasData = !!(substation || capacity);
  const callout = resolveSectionCallout(report, 'gridCapacity');
  return (
    <SectionShell label={label} hasData={hasData} report={report}>
      <PowerIntentIntroStrip report={report} focus="capacity" />
      {callout && (
        <EditorialCallout theme={theme} tone={callout.tone} label={callout.label} style={{ marginTop: 8 }}>
          {callout.body}
        </EditorialCallout>
      )}
      {substation && (
        <EditorialSubsection theme={theme} label="Substation">
          {walkClaimText(substation, report.references)}
        </EditorialSubsection>
      )}
      {/* K6 — dotted datum-strip band divider between the two subsections (the
           redesign's datum rhythm) so the substation and capacity bands read as
           distinct without a fat white gap. Rendered only when BOTH bands are
           present, so a single-band section stays clean. */}
      {substation && capacity && (
        <div className="my-4" data-testid="grid-capacity-datum">
          <EditorialDatumStrip theme={theme} role="hair" />
        </div>
      )}
      {capacity && (
        <EditorialSubsection theme={theme} label="Capacity">
          {walkClaimText(capacity, report.references)}
        </EditorialSubsection>
      )}
    </SectionShell>
  );
};
